export default __webpack_public_path__ + "static/media/Interior (1).264a47fa.jpg";